import type { ReactElement } from 'react';
import { useTheme } from '@simplywallst/ui-core';
import { IntroductionV2Wrapper } from './styled';
import { useDwellTracking } from '@/pages/CompanyReport/components/DwellTrackingProvider';
import { useReportSection } from '../ReportSectionProvider';

interface IntroductionProps {
  scoreName: string;
  /** Accepts a `<CriteriaChecks/>` component */
  criteriaChecks: ReactElement;
  /** Accepts a `<KeyInformation/>` component */
  keyInformation: ReactElement;
  /** Accepts a `<RecentSectionUpdates/>` component */
  recentSectionUpdates: ReactElement;
}
const Introduction = ({
  scoreName,
  criteriaChecks,
  keyInformation,
  recentSectionUpdates,
}: IntroductionProps) => {
  const { section } = useReportSection();
  const { observe } = useDwellTracking();
  const theme = useTheme();

  return (
    <IntroductionV2Wrapper
      data-cy-id={`${scoreName}-introduction`}
      data-section={section}
      ref={observe}
      templateColumns="1fr"
      templateColumnsMd="3fr 4fr"
      templateRows="repeat(3,auto)"
      templateRowsMd="auto auto"
      gap={`${theme.x2spacePx}px`}
    >
      {criteriaChecks}
      {keyInformation}
      {recentSectionUpdates}
    </IntroductionV2Wrapper>
  );
};

export default Introduction;
